import React,{ PureComponent } from 'react';
import { RadioButton } from 'reactstrap';
import classNames from 'classnames';
import CloseIcon from 'mdi-react/CloseIcon';
import PropTypes from 'prop-types';
import {
  CustomizerProps, SidebarProps, ThemeProps, RTLProps,
} from '../../../shared/prop-types/ReducerProps';
import ToggleTheme from './ToggleTheme';
import ToggleCollapsedMenu from './ToggleCollapsedMenu';
import ToggleSquared from './ToggleSquared';
import ToggleShadow from './ToggleShadow';
import ToggleTopMenu from './ToggleTopMenu';
import ToggleRTL from './ToggleRTL';
import reportData from './../../Dashboards/Default/dynamic';
import staticData from './../../Dashboards/Default/static';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from "@fortawesome/free-solid-svg-icons";

const settings = `${process.env.PUBLIC_URL}/img/settings.svg`;


export default class Customizer extends PureComponent {

  state = {
    open: false,
	  static_checked : true,
	  dynamic_checked : false,
  };

  handleOpen = () => {
    this.setState(prevState => ({ open: !prevState.open }));
  };
  
  handleStaticChecked = () => {  
	  this.setState({static_checked: !this.state.static_checked});
	  this.setState({dynamic_checked: this.state.static_checked});
	  if(!this.state.static_checked == true){
		  this.setState({items:this.props.static_items});
	  }
  };
  
  handleDynamicChecked = () => {
    this.setState({dynamic_checked: !this.state.dynamic_checked});
	  this.setState({static_checked: this.state.dynamic_checked});
    if(!this.state.dynamic_checked == true){
		  this.setState({items:this.props.items});
	  }
  };

  render() {
    const { open } = this.state;
    const customizerClass = classNames({
      customizer__wrap: true,
      'customizer__wrap--open': open,
    });
    

    return (
      <div className="customizer">
        <button className="customizer__btn" type="button" onClick={this.handleOpen}>
          
		  <span className="customizer__btn-icon" style={{fontSize: '20px',color: '#919193',animation: 'none'}}><FontAwesomeIcon icon={faCog}></FontAwesomeIcon></span>
        </button>
        <div className={customizerClass} hidden={!open}>
          <div className="customizer__title-wrap" style={{paddingBottom:'10px'}}>
            <h5>Dashboard Customizer</h5>
            <button className="customizer__close-btn" type="button" onClick={this.handleOpen} style={{top:'-8px'}}>
              <CloseIcon />
            </button>
          </div>
          
		  <form className="customizer__caption" style={{paddingTop:'10px'}}>
	<div className="row">	  
    <div className="col-xl-6 radio">
      <label>
        <input type="radio" value="option1" name="count" checked={this.state.static_checked} onChange={this.handleStaticChecked} style={{position:'relative',top:'2px'}}/>
        <span style={{paddingLeft:'6px',fontSize:'14px'}}>Static Tiles</span>
      </label>
    </div>
    <div className="col-xl-6 radio">
      <label>
        <input type="radio" value="option2" name="count" checked={this.state.dynamic_checked} onChange={this.handleDynamicChecked} style={{position:'relative',top:'2px'}}/>
        <span style={{paddingLeft:'6px',fontSize:'14px'}}>Dynamic Tiles</span>
      </label>
    </div>
	</div>
    
  </form>
          
      {
      this.state.dynamic_checked == true ?
      this.props.items.map((report_obj,index) => 
			  <ToggleCollapsedMenu  
				key={index} 
				report_obj={report_obj} 
				dynamic_tile_toggle={this.props.dynamic_tile_toggle}
        static_tile_toggle={this.props.static_tile_toggle}
        static_items={this.props.static_items}
        items = {this.props.items}
			/>
      ) : this.props.static_items.map((report_obj,index) => 
      <ToggleCollapsedMenu  
      key={index} 
      report_obj={report_obj} 
      dynamic_tile_toggle={this.props.dynamic_tile_toggle}
      static_tile_toggle={this.props.static_tile_toggle}
      static_items={this.props.static_items}
      items = {this.props.items}
    />
    )
  
      }
        </div>
      </div>
    );
  }
}
